import { Badge } from "@/components/ui/badge";

const map = {
  pending: "bg-amber-100 text-amber-800 border-amber-200",
  in_progress: "bg-amber-100 text-amber-800 border-amber-200",
  served: "bg-emerald-100 text-emerald-800 border-emerald-200",
  non_served: "bg-rose-100 text-rose-800 border-rose-200",
  completed: "bg-emerald-100 text-emerald-800 border-emerald-200",
  unable: "bg-rose-100 text-rose-800 border-rose-200",
  cancelled: "bg-slate-100 text-slate-700 border-slate-300",
};
const labels = {
  pending: "Pending",
  in_progress: "Pending",
  served: "Served",
  non_served: "Non-Served",
  completed: "Completed",
  unable: "Unable",
  cancelled: "Closed",
};

const kindMap = { service: "bg-sky-100 text-sky-900 border-sky-200", asset_search: "bg-fuchsia-100 text-fuchsia-900 border-fuchsia-200", record_retrieval: "bg-teal-100 text-teal-900 border-teal-200", document_courier: "bg-orange-100 text-orange-900 border-orange-200" };
const kindLabel = { service: "SOP", asset_search: "Asset", record_retrieval: "Records", document_courier: "Courier" };
export function KindBadge({ kind = "service" }) {
  return <Badge variant="outline" className={`${kindMap[kind] || kindMap.service} font-mono text-[10px] uppercase tracking-wider`} data-testid={`kind-badge-${kind}`}>{kindLabel[kind] || kind}</Badge>;
}

export function StatusBadge({ status }) {
  return (
    <Badge variant="outline" className={`${map[status] || map.pending} font-mono text-[10px] uppercase tracking-wider`}>
      {labels[status] || status}
    </Badge>
  );
}

const pri = {
  standard: "bg-slate-100 text-slate-800 border-slate-300",
  rush: "bg-amber-500 text-white border-amber-600",
  same_day: "bg-rose-600 text-white border-rose-700",
};
export function PriorityBadge({ priority }) {
  return (
    <Badge variant="outline" className={`${pri[priority] || pri.standard} font-mono text-[10px] uppercase tracking-wider`}>
      {priority?.replace("_", " ")}
    </Badge>
  );
}
